import React from "react";

export default function OnboardingImage() {
  return (
    <svg
      width="345"
      height="204"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path id="a" d="M0 .33h28.274v34.862H0z" />
        <path id="c" d="M.698.471h22.966v27.493H.698z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M178.239 41H69.87a4.46 4.46 0 00-4.46 4.458v31.969m0 32.172V89.437m0 32.956v62.149A4.46 4.46 0 0069.87 189h16.412m94.095 0h-49.953m62.304 0h80.222a4.459 4.459 0 004.46-4.458v-14.884M210.42 41h62.53a4.459 4.459 0 014.46 4.458v94.002"
          stroke="#425B9F"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M96.229 180H78.47a4.054 4.054 0 01-4.06-4.047V55.047A4.054 4.054 0 0178.47 51H263.35a4.054 4.054 0 014.06 4.047v120.906a4.054 4.054 0 01-4.06 4.047H117.916"
          stroke="#E7E9F0"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M101.41 158h120m-120-25.5h120m-120-25.5h120"
          stroke="#E7E9F0"
          strokeWidth="6"
          strokeLinecap="round"
        />
        <path
          d="M253.077 88H88.744c-1.841 0-3.334-1.5-3.334-3.35v-21.3A3.342 3.342 0 0188.744 60h164.333c1.84 0 3.333 1.5 3.333 3.35v21.3c0 1.85-1.492 3.35-3.333 3.35"
          fill="#F0F2F7"
        />
        <path
          d="M185.41 74.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0"
          fill="#61D3A7"
        />
        <path
          d="M206.41 74.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0"
          fill="#8FA1D2"
        />
        <path
          d="M226.41 74.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0"
          fill="#F2AB63"
        />
        <path
          d="M247.41 74.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0"
          fill="#52B8E1"
        />
        <path
          d="M247.41 132.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0"
          fill="#61D3A7"
        />
        <path
          d="M304.26 116.475l8.992 26.127a5.732 5.732 0 004.04 3.697l17.582 4.36c.61.151.733.964.195 1.287l-17.343 10.431a5.737 5.737 0 00-2.484 3.1l-8.682 26.04c-.219.656-1.152.64-1.346-.024l-7.286-24.925a5.727 5.727 0 00-3.372-3.713l-18.702-7.481a.705.705 0 01-.01-1.306l15.266-6.347a5.73 5.73 0 003.276-3.6l8.534-27.623c.201-.653 1.118-.667 1.34-.023M39.622 144.119l2.249 6.531c.158.46.538.808 1.01.925l4.395 1.09a.176.176 0 01.05.321l-4.337 2.609a1.43 1.43 0 00-.62.774l-2.171 6.51a.176.176 0 01-.337-.006l-1.822-6.23a1.434 1.434 0 00-.843-.93l-4.675-1.87a.176.176 0 01-.002-.325l3.816-1.588a1.43 1.43 0 00.819-.9l2.133-6.906c.051-.162.28-.166.335-.005"
          fill="#86E0C2"
        />
        <g transform="translate(.41 91)">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            d="M13.64.547l4.204 11.974a2.656 2.656 0 001.9 1.691l8.278 1.978a.32.32 0 01.09.59l-8.184 4.808c-.553.324-.97.829-1.175 1.424L14.63 34.97c-.103.3-.542.295-.634-.01l-3.4-11.425a2.638 2.638 0 00-1.585-1.7L.208 18.428a.32.32 0 01-.003-.6l7.201-2.93a2.676 2.676 0 001.548-1.656L13.008.558c.097-.298.529-.307.632-.011"
            fill="#75CFEC"
            mask="url(#b)"
          />
        </g>
        <g transform="translate(95.41 176)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" />
          </mask>
          <path
            d="M11.778.643l3.415 9.442c.24.664.821 1.166 1.542 1.334l6.725 1.56a.25.25 0 01.072.465l-6.648 3.792a2.11 2.11 0 00-.952 1.122l-3.35 9.43c-.084.239-.441.234-.514-.007l-2.763-9.01a2.107 2.107 0 00-1.288-1.34l-7.15-2.687a.25.25 0 01-.002-.472l5.849-2.312a2.139 2.139 0 001.257-1.306L11.265.65c.078-.235.428-.241.513-.008"
            fill="#FEC391"
            mask="url(#d)"
          />
        </g>
        <path
          d="M335.094 86.137l2.677 7.557c.188.53.644.933 1.21 1.067l5.27 1.247c.182.045.218.28.056.373l-5.21 3.034a1.68 1.68 0 00-.747.899l-2.625 7.546c-.066.19-.346.186-.404-.006l-2.166-7.21a1.67 1.67 0 00-1.008-1.073l-5.604-2.15a.2.2 0 01-.001-.377l4.583-1.851c.472-.19.834-.573.986-1.045l2.58-8.004c.062-.188.337-.193.403-.007"
          fill="#FEC391"
        />
        <path
          d="M131.576.143l2.826 7.9c.199.556.678.975 1.276 1.115l5.563 1.305a.21.21 0 01.06.39l-5.5 3.172a1.764 1.764 0 00-.789.94l-2.77 7.889c-.07.198-.365.194-.426-.006l-2.286-7.538a1.752 1.752 0 00-1.064-1.121l-5.916-2.249a.21.21 0 01-.001-.395l4.838-1.934c.499-.2.88-.6 1.04-1.093l2.725-8.367c.064-.197.355-.203.424-.008"
          fill="#75CFEC"
        />
        <path
          d="M249.41 43c0 14.36-13.655 26-30.5 26s-30.5-11.64-30.5-26 13.655-26 30.5-26 30.5 11.64 30.5 26"
          fill="#425BA1"
        />
        <path
          d="M216.41 44.5c0 5.8-4.7 10.5-10.5 10.5-5.798 0-10.5-4.7-10.5-10.5s4.702-10.5 10.5-10.5c5.8 0 10.5 4.7 10.5 10.5"
          fill="#FFF"
        />
        <path
          d="M214.41 45.5a5.5 5.5 0 11-10.999.001 5.5 5.5 0 0111-.001"
          fill="#3C3C3C"
        />
        <path
          d="M221.41 44.5c0 5.8 4.7 10.5 10.5 10.5 5.799 0 10.5-4.7 10.5-10.5S237.71 34 231.91 34c-5.8 0-10.5 4.7-10.5 10.5"
          fill="#FFF"
        />
        <path
          d="M224.41 45.5a5.5 5.5 0 1011 .001 5.5 5.5 0 00-11-.001"
          fill="#3C3C3C"
        />
        <path
          d="M71.68 29.028c-1.327-3.823 2.473-7.425 6.205-5.874 16.465 6.841 51.68 20.175 85.28 24.43 59.107 7.486 111.533-17.272 129.564-27.106 2.79-1.522 6.11.808 5.636 3.955-4.645 30.86-27.546 143.003-115.678 149.463-54.986 4.03-98.882-109.958-111.006-144.868"
          fill="#FFF"
        />
        <path
          d="M71.68 29.028c-1.327-3.823 2.473-7.425 6.205-5.874 16.465 6.841 51.68 20.175 85.28 24.43 59.107 7.486 111.533-17.272 129.564-27.106 2.79-1.522 6.11.808 5.636 3.955-4.645 30.86-27.546 143.003-115.678 149.463-54.986 4.03-98.882-109.958-111.006-144.868z"
          stroke="#B2BEE0"
          strokeWidth="3"
        />
        <path
          d="M74.41 25c7.085 9.335 77.623 53.676 131.984 46.143 19.363-2.685 35.371-8.438 57.016-22.15"
          stroke="#D2D9ED"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M73.41 24c3.811 14.47 62.673 118.045 95.938 128.111 24.549 7.43 45.062-9.455 45.062-9.455"
          stroke="#91A3D4"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M69.568 24.526l-.158 4.185c.323 1.556 1.83 2.553 3.367 2.228l.275-.058c1.537-.326 2.523-1.852 2.2-3.407l.158-4.186c-.322-1.555-1.83-2.552-3.367-2.226l-.273.058c-1.538.325-2.524 1.85-2.202 3.406"
          fill="#FFF"
        />
        <path
          d="M73.487 22.578a1.578 1.578 0 00-1.213-.23l-.259.055c-.867.184-1.133.975-1.244 1.932l-.131 4.149c.102.391.339.722.671.945.36.238.79.321 1.208.232l.266-.058c.42-.09.78-.339 1.015-.704a1.65 1.65 0 00.228-1.228l.131-4.148a1.614 1.614 0 00-.672-.945m-4.502 7.717c-.426-.633-.596-1.41-.573-2.177l.107-3.418c.102-1.44.004-2.202.836-3.218.594-.727 1.445-1.19 2.355-1.38.719-.151 1.475-.148 2.165.104a3.945 3.945 0 012.535 2.93l-.13 4.17a3.989 3.989 0 01-.891 3.292c-.574.682-1.389 1.111-2.252 1.297l-.003.001c-.845.182-1.739.136-2.526-.227a3.93 3.93 0 01-1.623-1.374"
          fill="#425BA1"
        />
        <path
          d="M82.453 22.34l.488 8.385c.257 1.507 1.602 2.505 3.005 2.23l.345-.07c1.404-.275 2.333-1.719 2.077-3.225l-.487-8.385c-.257-1.507-1.604-2.505-3.007-2.23l-.345.07c-1.403.274-2.333 1.719-2.076 3.225"
          fill="#FFF"
        />
        <path
          d="M84.538 20.32l-.382.067a1.632 1.632 0 00-1.054.65c-.25.345-.344.763-.264 1.174l.548 8.26c.085.39.32.727.669.958a1.7 1.7 0 001.229.251l.381-.067c.43-.074.805-.306 1.054-.65.25-.345.343-.762.263-1.174l-.545-8.26c-.186-.82-1.027-1.363-1.9-1.21m-3.523 10.514l-.548-8.271a3.697 3.697 0 01.662-2.827 4.027 4.027 0 012.597-1.604l.38-.067a4.162 4.162 0 013.024.621 3.83 3.83 0 011.679 2.481l.546 8.272a3.697 3.697 0 01-.66 2.827 4.037 4.037 0 01-2.598 1.605l-.38.066a4.162 4.162 0 01-3.023-.621 3.934 3.934 0 01-1.088-1.062 3.762 3.762 0 01-.591-1.42"
          fill="#425BA1"
        />
        <path
          d="M75.44 22.369l-.03 8.934c.184 1.663 1.669 2.863 3.317 2.678 1.648-.185 2.837-1.685 2.653-3.35l.03-8.934c-.183-1.664-1.668-2.863-3.317-2.678-1.649.184-2.836 1.685-2.653 3.35"
          fill="#FFF"
        />
        <path
          d="M78.234 20.355c-.95.11-1.638.997-1.532 1.978l-.03 8.728c.051.478.28.902.641 1.203a1.69 1.69 0 001.275.38c.46-.053.873-.288 1.162-.661.288-.374.42-.841.362-1.433l.036-8.612a1.833 1.833 0 00-.208-.673 1.719 1.719 0 00-1.706-.91m-3.824 10.85l.03-8.675c-.208-2.241 1.37-4.255 3.542-4.504 2.194-.252 4.178 1.38 4.428 3.77l-.036 8.61c.243 2.268-1.341 4.316-3.535 4.568a3.896 3.896 0 01-2.943-.88c-.4-.331-.729-.73-.977-1.188a4.534 4.534 0 01-.509-1.701"
          fill="#425BA1"
        />
        <path
          d="M301.161 23.457l.25 4.186c-.281 1.564-1.735 2.598-3.248 2.308l-.27-.051c-1.514-.29-2.513-1.792-2.233-3.357l-.25-4.185c.28-1.564 1.735-2.598 3.248-2.31l.269.053c1.514.289 2.514 1.792 2.234 3.356"
          fill="#FFF"
        />
        <path
          d="M296.637 22.563l.223 4.147c-.076.43.013.864.253 1.225.24.36.6.6 1.017.68l.262.05c.414.08.836-.013 1.185-.26a1.63 1.63 0 00.64-.96l-.222-4.15c-.132-.956-.412-1.74-1.27-1.904l-.257-.048a1.535 1.535 0 00-1.19.258c-.324.23-.55.57-.64.962m5.242 6.667a3.894 3.894 0 01-1.56 1.401c-.766.381-1.646.449-2.483.286h-.003c-.855-.166-1.667-.576-2.249-1.244a4.038 4.038 0 01-.952-3.273l-.223-4.171a3.936 3.936 0 012.432-2.992c.675-.27 1.419-.29 2.13-.156.901.169 1.75.612 2.353 1.326.842.996.763 1.762.896 3.199l.183 3.418c.04.767-.109 1.55-.515 2.193l-.009.013"
          fill="#425BA1"
        />
        <path
          d="M287.367 19.347l-.502 8.384c-.259 1.505-1.603 2.5-3.002 2.223l-.344-.07c-1.4-.279-2.324-1.725-2.065-3.23l.501-8.384c.26-1.507 1.604-2.502 3.003-2.223l.344.068c1.4.279 2.324 1.725 2.065 3.232"
          fill="#FFF"
        />
        <path
          d="M282.396 18.527l-.562 8.26a1.5 1.5 0 00.26 1.173c.248.344.621.577 1.052.652l.38.067c.43.077.865-.012 1.226-.25a1.54 1.54 0 00.671-.955l.564-8.26c.08-.41-.013-.829-.262-1.174a1.63 1.63 0 00-1.05-.652l-.381-.068c-.87-.155-1.712.386-1.898 1.207m4.8 10.732c-.283.413-.65.772-1.088 1.06a4.154 4.154 0 01-3.02.616l-.378-.068a4.017 4.017 0 01-2.59-1.61 3.702 3.702 0 01-.652-2.827l.562-8.271a3.838 3.838 0 011.68-2.478 4.147 4.147 0 013.02-.615l.38.067a4.022 4.022 0 012.588 1.609c.6.832.831 1.834.655 2.829l-.563 8.269a3.76 3.76 0 01-.594 1.419"
          fill="#425BA1"
        />
        <path
          d="M295.357 19.59l-.643 8.925c-.32 1.65-1.977 2.74-3.703 2.434-1.726-.305-2.867-1.89-2.547-3.54l.642-8.924c.32-1.65 1.978-2.74 3.704-2.434 1.726.305 2.866 1.89 2.547 3.54"
          fill="#FFF"
        />
        <path
          d="M290.694 18.158c-.13.193-.221.417-.267.658l-.592 8.602c-.104.586 0 1.062.274 1.457.274.396.689.66 1.167.748.476.087.96-.015 1.36-.286.4-.273.67-.68.758-1.153l.608-8.717a1.799 1.799 0 00-1.458-2.09 1.83 1.83 0 00-1.85.781m4.398 12c-.293.44-.665.812-1.109 1.113a4.215 4.215 0 01-3.14.659c-2.275-.416-3.782-2.578-3.363-4.825l.593-8.601c.437-2.367 2.63-3.849 4.904-3.435 2.254.411 3.755 2.54 3.374 4.763l-.603 8.664a4.399 4.399 0 01-.656 1.662"
          fill="#425BA1"
        />
      </g>
    </svg>
  );
}
